import WrapperLayout from 'components/Layout';
import Main from "./Components/Main"
const SequenceManager1 = () =>{
    return(
        <>
        <WrapperLayout>
            <Main/>
        </WrapperLayout>
    </>
    )
}
export default SequenceManager1